import React from 'react';
import { Dropdown } from 'semantic-ui-react';

export const PAGE_SIZE_OPTIONS_V8 = [10, 20, 50, 100].map((value) => ({
  key: value,
  text: String(value),
  value,
}));

export const readPageSizeV8 = (storageKey, fallback = 10) => {
  const value = Number(localStorage.getItem(storageKey));
  return PAGE_SIZE_OPTIONS_V8.some((option) => option.value === value)
    ? value
    : fallback;
};

const PageSizeSelectV8 = ({ label, onChange, storageKey, value }) => (
  <span className='page-size-control-v8'>
    <span>{label}</span>
    <Dropdown
      aria-label={label}
      compact
      selection
      options={PAGE_SIZE_OPTIONS_V8}
      value={value}
      onChange={(_, { value: nextValue }) => {
        localStorage.setItem(storageKey, String(nextValue));
        onChange(Number(nextValue));
      }}
    />
  </span>
);

export default PageSizeSelectV8;
